import React, { useState } from 'react';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import Pagination from './Pagination';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const styles = {
  root: {
    position: 'relative',
    marginBottom: '35px',
    width: '100%',
    margin: 'auto',
    alignItems: 'center',
  },
  slide: {
    padding: 15,
    minHeight: 100,
    color: '#fff',
    width: '100%',
  },
};

function SlideOneCard(props) {
  const { numberDots, dotStyles, seconds } = props;
  const [index = 0, setIndex] = useState();

  const handleChangeIndex = index => {
    setIndex(index);
  };

  return (
    <div style={styles.root}>
      <AutoPlaySwipeableViews
        interval={seconds ? seconds : 3000}
        index={index}
        onChangeIndex={handleChangeIndex}
      >
        {props.children}
      </AutoPlaySwipeableViews>
      <Pagination dots={numberDots} index={index} onChangeIndex={handleChangeIndex} dotStyles={dotStyles} />
    </div>
  );
}

export default SlideOneCard;
